<div class="wetter_content_container">
  <div style="display: inline-block; width: 45%; margin: auto" class="bericht-text-container"
       *ngFor="let region of ozonBericht?.regionen?.regionsListe">
    <span class="bericht-text-sub-label">{{region.name}}</span>
    <p>Konzentration: {{region.konzentration}}</p>
    <p>Trend: {{region.trend}}</p>
  </div>
</div>
